import { RootState } from 'redux/types';

export const getModalState = (store: RootState) => store.modal.isOpen;
export const getModalPlanning = (store: RootState) => store.modal.planning;
export const getTeams = (store: RootState) => store.teams.entities;
